import { render } from "./InvoiceBuyerForm.vue?vue&type=template&id=b82497f4&scoped=true"
import script from "./InvoiceBuyerForm.vue?vue&type=script&lang=js"
export * from "./InvoiceBuyerForm.vue?vue&type=script&lang=js"

import "./InvoiceBuyerForm.vue?vue&type=style&index=0&id=b82497f4&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82497f4"]])

export default __exports__